import React from 'react'

import DataBridgeSectionRowContainer from './DataBridgeSectionRowContainer'

type Props = {
  label: string
  value: string
  actionRenderer?: () => React.ReactNode
}

/**
 * A variant of DataBridgeKeyValue that is disconnected from the data bridge context. This is useful for
 * displaying key-value pairs that are not directly related to a data bridge or are nested in complex
 * types within a data bridge (e.g. destination fields).
 *
 * Note that skeleton loading patterns are not used here, it will be assumed that the data bridge
 * exists before this component is rendered.
 */
export default function GenericKeyValue({
  label,
  value,
  actionRenderer,
}: Props) {
  return (
    <DataBridgeSectionRowContainer>
      <div className="flex flex-1 flex-col space-y-1">
        <p
          className="text-foreground-normal text-base font-medium leading-5"
          data-testid="genericKeyValueLabel"
        >
          {label}
        </p>
        <p
          className="text-foreground-subtle text-base leading-5"
          data-testid="genericKeyValueValue"
        >
          {value}
        </p>
      </div>

      {actionRenderer && actionRenderer()}
    </DataBridgeSectionRowContainer>
  )
}
